export default __webpack_public_path__ + "static/instagram_4-d78bc90522cae7983323cd6fab65f654.jpg";